// TODO update to mui later
import { TableCell } from '@material-ui/core';
import * as React from 'react';
import { Shift } from 'services/helpers/shift';
import { SHIFTS_REF } from '../../constants/next-appointments.constants';

interface Props {
  message: string;
  shift?: Shift;
  classes: Record<string, string>;
}

export const GateClosedCell: React.FC<Props> = (props) => {
  const { message, shift, classes } = props;
  const className =
    shift?.shift === SHIFTS_REF.shift2 ? classes.cellNoAppointmentsFat : classes.cellNoAppointments;
  return (
    <TableCell className={className} align="center">
      {message}
    </TableCell>
  );
};
GateClosedCell.displayName = 'AppointmentsTable.GateClosedCell';
